import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { OnlyInDesktopTablet } from '@components/shared';
import { Address } from '@root/types';
import s from './Title.module.less';

const Separator = ({
  pipe = false,
  alwaysShow = false,
}: {
  pipe?: boolean;
  alwaysShow?: boolean;
}) => (
  <span className={cn(s.separator, pipe && s.pipeSeparator, alwaysShow && s.show)}>
    {pipe ? '|' : '-'}
  </span>
);

type Props = {
  address: Address;
  neighborhood: string | null;
};

const Title = ({ address, neighborhood = null }: Props) => {
  const { t } = useTranslation();
  const renderCityLocalityRegion = () => (
    <>
      <OnlyInDesktopTablet>
        <Separator pipe alwaysShow />
      </OnlyInDesktopTablet>
      {neighborhood ? (
        <>
          {neighborhood}
          <Separator pipe alwaysShow />
        </>
      ) : null}
      {t('common:cityLocalityRegion', { address })}
      <Separator pipe alwaysShow />
      {t(`country:${address.countryCode}`)}
    </>
  );

  return (
    <div className={s.container}>
      <div className={s.title}>
        <h1 className={s.titleText}>
          {address.buildingName || address.street}
          {address.buildingName ? (
            <div className={s.secondaryNameContainer}>
              <Separator />
              {address.street}
            </div>
          ) : null}
        </h1>
        <h2 className={s.secondaryInformation}>{renderCityLocalityRegion()}</h2>
      </div>
    </div>
  );
};

export default Title;
